<template>
  <v-card tile :loading="loading">
    <QuickMappingDialog />
    <v-row class="mr-3 mb-2 pt-5">
      <v-spacer></v-spacer>
      <v-text-field
        v-model="valueSearch"
        append-icon="mdi-magnify"
        :label="$t('form.search')"
        single-line
        flat
        hide-details
        style="max-width: 400px"
        class="pr-4"
        @input="searchItems"
      ></v-text-field>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="items"
      :items-per-page="itemsPerPage"
      :page="itemsPage"
      :server-items-length="totalItems"
      :sort-by="sortByField"
      :sort-desc="sortDesc"
      must-sort
      @update:page="updatePage($event)"
      @update:items-per-page="updateItemsPerPage($event)"
      @update:sort-by="updateSortBy($event)"
      @update:sort-desc="updateSortOrder($event)"
      :footer-props="footerProps"
      :loading-text="$t('table.loading', { prop: $t('input-values.title') })"
      :no-data-text="$t('table.no_data', { prop: $t('input-values.title') })"
    >
      <template v-slot:item.modifiedDt="{ item }">
        {{ new Date(item.modifiedDt).toLocaleString("nl-NL") }}
      </template>

      <template v-slot:item.actions="{ item }">
        <v-layout justify-start>
          <v-icon
            :aria-label="$t('value.quickmap-button')"
            @click="createQuickMapping(item)"
            :title="$t('value.quickmap-button')"
            v-if="item.mapped !== true"
          >
            mdi-tag-plus-outline
          </v-icon>
          <v-icon
            class="ml-3"
            :aria-label="$t('value.table.ignore_add')"
            @click.stop="ignoreMapping(item)"
            :title="$t('value.table.ignore_add')"
            v-if="item.ignored === false"
          >
            mdi-tag-off-outline
          </v-icon>
        </v-layout>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import QuickMappingDialog from "@/components/attribute/mappingCreation/QuickMappingDialog";

export default {
  name: "InputValues",
  components: {
    QuickMappingDialog
  },
  data: vm => ({
    ignoredDialog: false,
    headers: [
      {
        text: vm.$tc("value.table.value"),
        value: "content"
      },
      // {
      //   text: vm.$t("value.table.modified_by"),
      //   value: "modifiedBy"
      // },
      {
        text: vm.$t("value.table.modified_dt"),
        value: "modifiedDt"
      },
      {
        text: vm.$t("value.table.actions"),
        value: "actions",
        sortable: false
      }
    ]
  }),
  computed: {
    ...mapState("attributeOverview", ["attribute"]),
    ...mapState("attributeOverview/inputValueOverview", [
      "loading",
      "items",
      "totalItems",
      "itemsPage",
      "itemsPerPage",
      "sortByField",
      "sortDesc",
      "footerProps"
    ]),
    mappedStatus: {
      get() {
        return this.$store.state.attributeOverview.inputValueOverview
          .mappedStatus;
      },
      set(value) {
        this.setMappedStatus(value);
      }
    },
    valueSearch: {
      get() {
        return this.$store.state.attributeOverview.inputValueOverview
          .valueSearch;
      },
      set(value) {
        this.setValueSearch(value);
      }
    }
  },
  mounted() {
    this.$store.state.attributeOverview.inputValueOverview.mappedStatus = false;
    this.$store.state.attributeOverview.inputValueOverview.ignoredStatus = false;
    this.$store.state.attributeOverview.inputValueOverview.sortByField = "name";
    this.$store.state.attributeOverview.inputValueOverview.sortDesc = false;
    this.$store.state.attributeOverview.inputValueOverview.itemsPerPage = 25;
    this.searchItems();
  },
  methods: {
    ...mapActions("modelDialog", ["showModelDialog"]),
    ...mapActions("snackbar", ["showSnack"]),
    ...mapActions("attributeOverview/inputValueOverview", [
      "searchItems",
      "updatePage",
      "updateItemsPerPage",
      "updateSortBy",
      "updateSortOrder",
      "setValueSearch",
      "setMappedStatus",
      "setValue",
      "editValue"
    ]),
    getMappedOption(item) {
      return this.mappedOptions.find(x => x.value == item.mapped);
    },
    createQuickMapping(item) {
      this.setValue(item);
      this.showModelDialog("QuickMappingDialog");
    },
    async ignoreMapping(item) {
      item.ignored = true;
      this.editValue(item)
        .then(() => {
          this.showSnack({
            text: this.$t("value.actions.add-ignore_successful", {
              value: item.content
            }),
            color: "success"
          });
        })
        .catch(errorMessage => {
          this.showSnack({ text: errorMessage, color: "error" });
        });
    }
  }
};
</script>
